import { useCallback, useEffect, useRef } from 'react'

/**
 * Defers blur handling so focus can move within the select root before firing
 * the external blur callback.
 */
export const useContainedBlur = (onBlur?: () => void) => {
  const rootRef = useRef<HTMLDivElement | null>(null)
  const blurTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(
    () => () => {
      if (blurTimeoutRef.current) clearTimeout(blurTimeoutRef.current)
    },
    [],
  )

  const handleBlur = useCallback(() => {
    if (blurTimeoutRef.current) clearTimeout(blurTimeoutRef.current)
    blurTimeoutRef.current = setTimeout(() => {
      if (typeof document === 'undefined') {
        onBlur?.()
        return
      }

      const activeElement = document.activeElement
      if (rootRef.current && activeElement && rootRef.current.contains(activeElement)) return
      onBlur?.()
    }, 0)
  }, [onBlur])

  return { rootRef, handleBlur }
}
